import {
  FormElementCaptchaData,
  FormElementCaptchaModel
} from '@/components/addons/registration/Models/FormElementCaptchaModel';
import {
  FormElementCheckboxData,
  FormElementCheckboxModel
} from '@/components/addons/registration/Models/FormElementCheckboxModel';
import { FormElementCvrData, FormElementCVRModel } from '@/components/addons/registration/Models/FormElementCVRModel';
import {
  FormElementDateData,
  FormElementDateModel
} from '@/components/addons/registration/Models/FormElementDateModel';
import {
  FormElementDawaData,
  FormElementDawaModel
} from '@/components/addons/registration/Models/FormElementDawaModel';
import {
  FormElementDividerData,
  FormElementDividerModel
} from '@/components/addons/registration/Models/FormElementDividerModel';
import {
  FormElementFileData,
  FormElementFileModel
} from '@/components/addons/registration/Models/FormElementFileModel';
import {
  FormElementLocationData,
  FormElementLocationModel
} from '@/components/addons/registration/Models/FormElementLocationModel';
import {
  FormElementMaskData,
  FormElementMaskModel
} from '@/components/addons/registration/Models/FormElementMaskModel';
import {
  FormElementRadioData,
  FormElementRadioModel
} from '@/components/addons/registration/Models/FormElementRadioModel';
import {
  FormElementRatingData,
  FormElementRatingModel
} from '@/components/addons/registration/Models/FormElementRatingModel';
import {
  FormElementSelectData,
  FormElementSelectModel
} from '@/components/addons/registration/Models/FormElementSelectModel';
import {
  FormElementSignatureData,
  FormElementSignatureModel
} from '@/components/addons/registration/Models/FormElementSignatureModel';
import {
  FormElementSliderData,
  FormElementSliderModel
} from '@/components/addons/registration/Models/FormElementSliderModel';
import {
  FormElementTextareaData,
  FormElementTextareaModel
} from '@/components/addons/registration/Models/FormElementTextareaModel';
import {
  FormElementTextData,
  FormElementTextModel
} from '@/components/addons/registration/Models/FormElementTextModel';
import { MetricData, ReplacementTags } from '@/store/modules/global/state';
import {
  FormElementParagraphData,
  FormElementParagraphModel
} from '@/components/addons/registration/Models/FormElementParagraphModel';
import { FormElementHiddenModel } from '@/components/addons/registration/Models/FormElementHiddenModel';
import { FormElementReCaptchaModel } from '@/components/addons/registration/Models/FormElementReCaptchaModel';
import { CampaignMessageData } from '@/typings/interfaces/data/campaign';

export type FormElementData =
  | FormElementCaptchaData
  | FormElementParagraphData
  | FormElementCheckboxData
  | FormElementCvrData
  | FormElementDateData
  | FormElementDawaData
  | FormElementDividerData
  | FormElementFileData
  | FormElementLocationData
  | FormElementMaskData
  | FormElementRadioData
  | FormElementRatingData
  | FormElementSelectData
  | FormElementSignatureData
  | FormElementSliderData
  | FormElementTextareaData
  | FormElementTextData;

export type FormElementModel =
  | FormElementReCaptchaModel
  | FormElementCaptchaModel
  | FormElementCheckboxModel
  | FormElementCVRModel
  | FormElementDateModel
  | FormElementDawaModel
  | FormElementDividerModel
  | FormElementFileModel
  | FormElementLocationModel
  | FormElementMaskModel
  | FormElementRadioModel
  | FormElementRatingModel
  | FormElementSelectModel
  | FormElementSignatureModel
  | FormElementSliderModel
  | FormElementParagraphModel
  | FormElementTextareaModel
  | FormElementTextModel
  | FormElementHiddenModel;

export type FormElementModelType =
  | typeof FormElementCaptchaModel
  | typeof FormElementCheckboxModel
  | typeof FormElementCVRModel
  | typeof FormElementDateModel
  | typeof FormElementDawaModel
  | typeof FormElementDividerModel
  | typeof FormElementFileModel
  | typeof FormElementLocationModel
  | typeof FormElementMaskModel
  | typeof FormElementRadioModel
  | typeof FormElementRatingModel
  | typeof FormElementSelectModel
  | typeof FormElementSignatureModel
  | typeof FormElementParagraphModel
  | typeof FormElementSliderModel
  | typeof FormElementTextareaModel
  | typeof FormElementTextModel
  | typeof FormElementReCaptchaModel
  | typeof FormElementHiddenModel;

export const FormElementMapping: Record<string, FormElementModelType> = {
  text: FormElementTextModel,
  email: FormElementTextModel,
  tel: FormElementTextModel,
  textarea: FormElementTextareaModel,
  checkbox: FormElementCheckboxModel,
  select: FormElementSelectModel,
  date: FormElementDateModel,
  radio: FormElementRadioModel,
  rating: FormElementRatingModel,
  signature: FormElementSignatureModel,
  cvr: FormElementCVRModel,
  divider: FormElementDividerModel,
  slider: FormElementSliderModel,
  dawa: FormElementDawaModel,
  file: FormElementFileModel,
  hidden: FormElementHiddenModel,
  mask: FormElementMaskModel,
  captcha: FormElementCaptchaModel,
  location: FormElementLocationModel,
  paragraph: FormElementParagraphModel,
  recaptcha: FormElementReCaptchaModel
};

export interface RegistrationApiResponse {
  object?: {
    id: string;
    token: string;
    prize_id?: number;
    winner?: boolean;
  };
  show_message: CampaignMessageData;
  token_expired: boolean;
  error?: boolean;
  message?: string;
  isError: boolean;
  replacementtags?: ReplacementTags;
  metrics?: MetricData;
  votes?: MetricData;
  goto_flow_page?: number;
  errors?: {
    [key: string]: string[];
  };
  ghostedUser: boolean;
}

export interface FieldOptionItem {
  label: string;
  value: string;
  selected?: boolean;
}
